import InputField from 'components/fields/InputField';

const Password = () => {
 return (
 <div className="rounded-xl border border-leadrs-stroke bg-white px-4 py-4">
 {/* Header */}
 <div className="w-full px-1">
 <h4 className="text-base font-bold text-leadrs-text">
 Modifier son mot de passe
 </h4>
 <p className="mt-2 text-sm">
 Vous avez perdu votre mot de passe ? Rendez-vous sur la page{' '}
 <span
 className="text-leadrs-brand underline hover:cursor-pointer"
 onClick={() =>
 window.open(
 '/auth/forgot-password/default',
 '_blank'
 )
 }
 >
 mot de passe oublié
 </span>{' '}
 .
 </p>
 </div>
 {/* inputs */}
 {/* <div className="mt-5 grid grid-cols-1 gap-3">
 <InputField
 label="Ancien mot de passe"
 placeholder="*********"
 id="oldPassword"
 type="text"
 />
 <InputField
 label="Nouveau mot de passe"
 placeholder="*********"
 id="password"
 type="text"
 />
 <InputField
 label="Nouveau mot de passe"
 placeholder="*********"
 id="passwordConfirm"
 type="text"
 />

 <div className="mt-2 flex w-full justify-end">
 <button className="linear rounded-xl bg-brand-200 px-8 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-200 active:bg-brand-200">
 Changer mon mot de passe
 </button>
 </div>
 </div> */}
 {/* full width inputs */}
 </div>
 );
};

export default Password;
